import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { resolveLocale } from '@/shared/localization';
import { safeT } from '@/shared/localization';
import { useLocale, useTranslations } from 'next-intl';
import { filterDetailTonesByLocale } from '../lib/filterDetailTonesByLocale';
import { useMetadata } from './useMetaData';
export default function useDetailTemplate() {
  const $ = _c(18);
  const t = useTranslations("meta");
  const t0 = useLocale();
  let t1;
  if ($[0] !== t0) {
    t1 = resolveLocale(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const locale = t1;
  const {
    data: t2
  } = useMetadata();
  let t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? {
      detail: {
        templates: [],
        tones: []
      }
    } : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const meta = t3;
  let t4;
  if ($[4] !== locale || $[5] !== meta.detail.tones || $[6] !== t) {
    let t5;
    if ($[8] !== t) {
      t5 = tone => ({
        label: safeT(t, `detail.${tone}.name`, tone),
        caption: safeT(t, `detail.${tone}.description`, tone),
        value: tone
      });
      $[8] = t;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    t4 = filterDetailTonesByLocale(meta.detail.tones, locale).map(t5);
    $[4] = locale;
    $[5] = meta.detail.tones;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const tones = t4;
  let t5;
  if ($[10] !== meta.detail.templates || $[11] !== t) {
    let t6;
    if ($[13] !== t) {
      t6 = template => ({
        label: safeT(t, `detail.${template.key}.name`, template.key),
        value: template.key,
        thumbnail: template.image,
        tooltip: safeT(t, `detail.${template.key}.tooltip`, template.key)
      });
      $[13] = t;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = meta.detail.templates.map(t6);
    $[10] = meta.detail.templates;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const templates = t5;
  let t6;
  if ($[15] !== templates || $[16] !== tones) {
    t6 = {
      templates,
      tones
    };
    $[15] = templates;
    $[16] = tones;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}